import styled from 'styled-components';
import { IToken } from 'store/ducks/globalTypes';
import CustomIconButton from '../CustomIconButton';

export const StyledCustomIconButton = styled(CustomIconButton)<IToken>`
  margin-top: ${(props) => `${props.token.marginXXS}px`};
`;

export const TextAreaElementsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  margin-top: 6px;
  place-items: center;
`;

export const StyledButtonSection = styled.div<IToken>`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => `${props.token.marginSM}px`};
  flex-shrink: 0;
`;
